// extracted by mini-css-extract-plugin
export default {"button":"Oj-z","reviewSort":"Pj-z"};